export const ANDROID_CAMERA_MOBILE_CONSTRAINTS = {
    width: {
        ideal: 99999,
    },
    height: {
        ideal: 99999,
    },
};

export const IOS_CAMERA_MOBILE_CONSTRAINTS = {
    width: {
        ideal: 4096,
        min: 480,
    },
    height: {
        ideal: 2160,
        min: 320,
    },
};
